export default __webpack_public_path__ + "static/media/about-us-img-06.d043817b.jpg";